import markdownToReact from '@sr/rich-text/markdown-to-react';
import { DetailSectionItem } from '@sr/types';
import React from 'react';
import SummaryLegacy from './SummaryLegacy';
import {
  Box,
  Em,
  List,
  ListItem,
  OrderedList,
  Paragraph,
  Strong,
  WebsiteLink,
} from './ui';

function getComponentMap() {
  return {
    ul: SummaryList,
    ol: SummaryOrderedList,
    li: SummaryListItem,
    p: Paragraph,
    a: SummaryLink,
    strong: SummaryStrong,
    em: SummaryEm,
    div: Box,
  };
}

// These specific props are required by rehype-react
type Props<T> = React.DetailedHTMLProps<React.HTMLAttributes<T>, T>;

function SummaryList(props: Props<HTMLUListElement>) {
  return <List variant="summaryList">{props.children}</List>;
}
function SummaryOrderedList(props: Props<HTMLOListElement>) {
  return <OrderedList variant="summaryList">{props.children}</OrderedList>;
}
function SummaryListItem(props: Props<HTMLLIElement>) {
  return <ListItem variant="summaryListItem">{props.children}</ListItem>;
}
function SummaryStrong(props: Props<HTMLElement>) {
  return <Strong sx={{ fontWeight: 'bold' }}>{props.children}</Strong>;
}
function SummaryEm(props: Props<HTMLElement>) {
  return <Em sx={{ fontStyle: 'italic' }}>{props.children}</Em>;
}

// These props are stricter than the rest
type SummaryLinkProps = React.DetailedHTMLProps<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;
/* eslint-disable react/prop-types */
function SummaryLink(props: SummaryLinkProps) {
  return (
    <WebsiteLink
      url={props.href}
      sx={{
        textDecoration: 'underline',
      }}
    >
      {props.children}
    </WebsiteLink>
  );
}

type SummaryProps = Pick<DetailSectionItem, 'summary' | 'textType'> & {
  itemId?: string;
};

export default function Summary({ summary, textType }: SummaryProps) {
  const componentMap = getComponentMap();
  // Render the legacy Summary component if the textType hasn't been upgraded to markdown
  if (textType !== 'markdown') {
    return <SummaryLegacy summary={summary} />;
  } else {
    return <Box>{markdownToReact(summary, componentMap)}</Box>;
  }
}
